import { FC } from "react";
import { Box, Card, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { IAreaDataItem } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/StructureAreas.models";
import { styles } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/styles";
import { Link } from "react-router-dom";
import { Avatar, PresenceIndicator } from "@benefit-systems/hr-tools-ui";
import OrgchartAsManagerIcon from "src/Pages/Company/OrganizationStructure/assets/icons/DefaultOrgchartManagerIcon.svg";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import useIsAhr from "src/utils/hooks/useIsAhr";

const AreaResult: FC<IAreaDataItem> = ({
  areaId,
  manager,
  name,
  membersNumber,
  structureAvatar,
  structure,
}) => {
  const companyId = useCompanyId();
  const isAhr = useIsAhr();
  return (
    <Card key={`Area_Card_${areaId}`} sx={{ p: 3 }} data-testid="os__area-card">
      <Typography
        component={Link}
        variant="h4"
        fontWeight="fontWeightBold"
        to={
          isAhr
            ? `/ahr/organization-structure/configure-structure/area/${areaId}`
            : `/company/edit/${companyId}/organization-structure/configure-structure/area/${areaId}`
        }
        style={{
          textDecoration: "none",
          color: "#000",
        }}
        data-testid="os__area-card-title"
      >
        {__(`${name}`)}
      </Typography>
      <Typography fontWeight="fontWeightBold" data-testid="os__area-card-member-count">{`${__(
        "Pracowników"
      )}: ${membersNumber}`}</Typography>
      <Box
        sx={{ height: "1px", backgroundColor: "#F2F2F2", margin: "8px 0" }}
      />
      <Typography
        variant="body2"
        fontWeight="fontWeightMedium"
        sx={styles.AreaResult.manager}
      >
        {__("Osoba zarządzająca")}
      </Typography>
      <Box sx={styles.AreaResult.avatarContainer}>
        {/* eslint-disable-next-line */}
        {manager ? (
          <PresenceIndicator status={manager.presenceInformation?.status}>
            <Avatar src={manager.avatar} alt="managerAvatar" size={13} data-testid="os__area-card-manager-avatar">
              {manager.initials}
            </Avatar>
          </PresenceIndicator>
        ) : structureAvatar ? (
          <Avatar src={structureAvatar} size={13} alt="managerAvatar" data-testid="os__area-card-manager-avatar" />
        ) : (
          <Box
            sx={{
              backgroundColor: "#bdbdbd",
              borderRadius: "100%",
              padding: "10px",
              width: "48px",
              height: "48px",
            }}
            data-testid="os__area-card-manager-avatar"
          >
            <img
              style={{ maxWidth: "100%" }}
              src={OrgchartAsManagerIcon}
              alt="ManagerDefaultIcon"
            />
          </Box>
        )}

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography fontWeight="fontWeightMedium" sx={{ lineHeight: "1" }} data-testid="os__area-card-manager-name">
            {manager?.name || structure?.label}
          </Typography>
          {manager?.fk && (
            <Typography
              sx={{ color: "#838C96" }}
            >{`(FK ${manager.fk})`}</Typography>
          )}
          {manager?.position && (
            <Typography sx={{ color: "#838C96" }}>
              {__(`${manager.position.label}`)}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default AreaResult;
